import { useQuery } from '@tanstack/react-query';
import { GetDownloadVideoURLRequest } from '@/components/ui/Inputs/types/request/file';
import { validateUuid } from '@/utils/validate-uuid';
import Api from '@/services/api';

const SIGNED_URL_STALE_TIME_MS = 55 * 60 * 1000;

async function getDownloadVideoURL(payload: GetDownloadVideoURLRequest) {
	const url = '/upload/create-url-download';
	const { data } = await Api.post<string>(url, payload);
	return data;
}

interface GetDownloadVideoURLParams extends GetDownloadVideoURLRequest {
	isVideoUnavailable?: boolean;
}

export const useGetDownloadVideoURL = ({
	organization_id,
	company_id,
	file_id,
	original_name,
	isVideoUnavailable
}: GetDownloadVideoURLParams) => {
	const parameters = { organization_id, company_id, file_id, original_name: original_name ?? file_id };
	const ids = [organization_id ?? '', company_id ?? '', file_id];
	const enabled = validateUuid(ids) && !isVideoUnavailable;

	return useQuery(['download_video_url', parameters], () => getDownloadVideoURL(parameters), {
		enabled,
		staleTime: SIGNED_URL_STALE_TIME_MS,
		cacheTime: SIGNED_URL_STALE_TIME_MS,
		refetchOnWindowFocus: false
	});
};
